// FullStory - commented out: import { FullStoryTrackErrorEvent } from '../services/full-story-set-user.service';

export const responseErrorInterceptor = (error: any) => {
  // FullStory - commented out: FullStoryTrackErrorEvent(error);
  return Promise.reject(error);
};
